import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { EmptyIcon } from '@creditornot/cb-placeholders';
import React, { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  style?: CSSProperties;
  message?: React.ReactNode;
};

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MenuIcon = styled(EmptyIcon.FileText)`
  margin-block-start: 64px;
  margin-block-end: 16px;
`;

const Title = styled(T.Body3)`
  color: ${cbSemanticCssVars.textTertiary};
`;

const EmptyList = ({ style, message }: Props) => {
  return (
    <Root style={style}>
      <MenuIcon />
      <Title>{message ? message : <FormattedMessage id="menu.noItems" />}</Title>
    </Root>
  );
};

export default EmptyList;
